export const sfbFaqs = [
  {
    question: "What is Spitface Battles?",
    answer: "Spitface Battles is a structured, competitive system for battle rap. It goes beyond social or content platforms by focusing on measurable competition, reputation-based progression, and systems that reward consistent participation."
  },
  {
    question: "What is the beta and why should I join?",
    answer: "The beta is early access to Spitface Battles where you can participate in structured battles, judging, and feedback. Joining lets you earn a role, influence the platform's systems, and experience SFB before public launch."
  },
  {
    question: "What are beta roles?",
    answer: "Beta roles define how you participate. Founding 50, Day Ones, Influencers, and League Hosts are earned, structured, and gated, with role-specific responsibilities and recognition within the beta."
  },
  {
    question: "How do I reserve my username?",
    answer: "Usernames can be reserved directly on the beta signup page. Reserving early ensures you keep the identity you want, and is separate from applying for a beta role."
  },
  {
    question: "What does participation look like?",
    answer: "Participation depends on your role. Battlers compete in battles, judges score, influencers grow engagement, and League Hosts bring their battlers to Spitface Battles."
  },
  {
    question: "Are there rewards or special access?",
    answer: "Rewards and recognition are role-specific and conditional on participation. Beta roles provide access to certain features and early experiences, but signing up alone does not guarantee perks."
  },
  {
    question: "Do I need a following to join?",
    answer: "Not for all roles. Influencers benefit from having an audience, but participation roles like Founding 50 or Day Ones are based on engagement and participation, not prior reach."
  },
  {
    question: "How long is the beta?",
    answer: "The beta is planned as a 12-month rollout across 3 phases. Timelines may shift, but each phase is designed to help test, refine, and expand the platform over time."
  },
  {
    question: "Will my activity affect the main platform later?",
    answer: "Beta participation contributes to shaping SFB's systems and features, but it does not guarantee specific privileges or outcomes on the public platform. Your actions influence the beta experience, and feedback informs future platform design."
  }
];

export default sfbFaqs;
